import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { OrderOperator, Order } from '../mixins/filterHandler/lib';
import type { OrderOperatorType } from '../mixins/filterHandler/lib';
import type { ColumnInfo, ElementUISlotScope } from '@/lib/types/components';

interface Props {
	dataOrder?: Order | null;
	columnInfo?: ColumnInfo | ElementUISlotScope | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SortableColumnHeader',
  props: {
    dataOrder: { default: null },
    columnInfo: { default: null }
  },
  emits: ['order-change'],
  setup(__props: any, { emit }) {

const props = __props as { dataOrder: Order | null, columnInfo: ColumnInfo | ElementUISlotScope | null };



// Definizione eventi (Vue 2.7 style)


// Computed - Order info per la colonna corrente
const order = computed(() => {
	if (!props.columnInfo?.column?.property) {
		return null;
	}
	if (!props.dataOrder || !(props.dataOrder instanceof Order)) {
		return null;
	}
	const orderInfo = props.dataOrder.getOrder(props.columnInfo.column.property);
	if (orderInfo) {
		orderInfo.label = props.columnInfo.column.label;
	}
	return orderInfo;
});

// Computed - Operator corrente
const operator = computed(() => {
	const orderInfo = order.value;
	if (!orderInfo) {
		return OrderOperator.IGNORE;
	}
	return orderInfo.operator;
});

// Computed - Classi CSS per lo stato di ordinamento
const computedClasses = computed(() => {
	const op = operator.value;
	return op === OrderOperator.IGNORE ? '' : op === OrderOperator.ASCENDING ? 'asc' : 'desc';
});

// Methods - Toggle dell'ordinamento
const toggle = (direction: 'asc' | 'desc') => {
	if (!props.columnInfo?.column?.property) {
		return;
	}

	const currentOp = operator.value;

	if (direction === 'asc') {
		const newOp =
			currentOp === OrderOperator.ASCENDING ? OrderOperator.IGNORE : OrderOperator.ASCENDING;
		emit('order-change', props.columnInfo.column.property, newOp);
	}

	if (direction === 'desc') {
		const newOp =
			currentOp === OrderOperator.DESCENDING ? OrderOperator.IGNORE : OrderOperator.DESCENDING;
		emit('order-change', props.columnInfo.column.property, newOp);
	}
};

return { __sfc: true,props, emit, order, operator, computedClasses, toggle }
}

})